function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 24.467l-1.933-1.76C5.2 16.48.667 12.373.667 7.333.667 3.227 3.893 0 8 0c2.32 0 4.547 1.08 6 2.787C15.453 1.08 17.68 0 20 0c4.107 0 7.333 3.227 7.333 7.333 0 5.04-4.533 9.147-11.4 15.387L14 24.467z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgHeartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 25"
  }, props), _ref);
}

export default SvgHeartSolid;